import React, { useState, useEffect } from "react";
import { GrFormNext } from "react-icons/gr";
import { IoIosArrowBack } from "react-icons/io";
import { FaCalendarAlt, FaClock } from "react-icons/fa";
/* import { ImCross } from "react-icons/im"; */
import { RxCross2 } from "react-icons/rx";
/* import { configData } from "../data/configData";
import { events } from "../data/event";  */
import "../App.css";
import { data } from "react-router-dom";
import { ImCross } from "react-icons/im";
import { createbooking, getAllbooking } from "../api/booking";
import { getAllConfig } from "../api/configapi";


const Booking = () => {
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [menuOpen, setMenuOpen] = useState(false);
  const [sel, setSel] = useState();
  const [date, setDate] = useState();
  const [formData, setFormData] = useState({});
  const [viewOpen, setViewOpen] = useState(false);
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");
  const [eventList, setEventList] = useState([]);
  const [bookings, setBooking] = useState([]);
  const [events, setConfigData] = useState([]);
  const[viewBill,setViewBill] = useState(false);
  const dayOfWeek = ["ஞாயிறு", "திங்கள்", "செவ்வாய்", "புதன்", "வியாழன்", "வெள்ளி", "சனி"];
  const months = [
    "ஜனவரி",
    "பிப்ரவரி",
    "மார்ச்",
    "ஏப்ரல்",
    "மே",
    "ஜூன்",
    "ஜூலை",
    "ஆகஸ்ட்",
    "செப்டம்பர்",
    "அக்டோபர்",
    "நவம்பர்",
    "டிசம்பர்",
  ];

  const handleDayClick = (day) => {
    if (day) {
      setSelectedDate(day);
    }
  };

  const formatDate = (date) => {
    const day = String(date.getDate()).padStart(2, "0"); // e.g., 04
    const month = String(date.getMonth() + 1).padStart(2, "0"); // e.g., 07
    const year = date.getFullYear().toString().slice(-2); // e.g., 25
    return `${day}/${month}/${year}`;
  };

  const isSameDay = (d1, d2) =>
    d1.getDate() === d2.getDate() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getFullYear() === d2.getFullYear();

  const handleChange = (fields, value) => {
    setFormData((prev) => ({
      ...prev,
      [fields]: value,
    }));
  };

  const handleFiedlsChange = (field, data) => {
    console.log({ field, data });
    setFormData((prev) => {
      const existingFields = prev?.feilds || [];

      // Check if the field already exists
      const updatedFields = existingFields.some((f) => f.label === field)
        ? existingFields.map((f) =>
            f.label === field ? { ...f, value: data } : f
          )
        : [...existingFields, { label: field, value: data }];

      return {
        ...prev,
        feilds: updatedFields,
      };
    });
  };

  const selectedConfig = events.find((c) => c.date === date);

  const configDates = events.map((item) => item.date);
  const selectedFormattedDate = formatDate(selectedDate);

  const daysInMonth = () => {
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const numDays = new Date(year, month + 1, 0).getDate();

    const calendar = [];
    for (let i = 0; i < firstDay; i++) calendar.push(null);
    for (let i = 1; i <= numDays; i++) {
      calendar.push(new Date(year, month, i));
    }
    return calendar;
  };

  const selectedEvents = bookings.filter(
    (item) => formatDate(new Date(item.date)) === selectedFormattedDate
  );

  const hasTimeEvent = bookings.some(
    (event) =>
      event.date === selectedFormattedDate &&
      event.startTime?.trim() !== "" &&
      event.endTime?.trim() !== ""
  );

  const handleSubmit = async () => {
    const newEvent = {
      event: sel,
      date: new Date(selectedDate),
      ...formData,
    };

    console.log("Payload to submit:", newEvent); // <-- Debug

    try {
      const res = await createbooking(newEvent);
      console.log("Event created:", res);

      const updatedList = await getAllbooking();
      setEventList(Array.isArray(updatedList?.data) ? updatedList.data : []);

      setFormData({});
      setSel("");
      setStartTime("");
      setEndTime("");
      setMenuOpen(false);
    } catch (err) {
      console.error("Create booking failed:", err);
    }
  };

  useEffect(() => {
    getAllConfig()
      .then((res) => {
        // ✅ Check if response data is an array
        if (Array.isArray(res.data)) {
          setConfigData(res.data);
        } else {
          console.error("Expected array but got:", res.data);
          setConfigData([]); // fallback to empty array
        }
      })
      .catch((err) => {
        console.error("Failed to fetch config:", err);
        setConfigData([]); // fallback on error
      });
  }, []);

  useEffect(() => {
    getAllbooking()
      .then((res) => setBooking(res.data))
      .catch((err) => console.log(err));
  }, []);

  return (
    <div className=" mt-[5%] md:px-10  ">
      <div className=" rounded-xl flex  flex-col lg:flex-row gap-6 px-4 py-6 shadow-md">
<div className=" flex flex-col md:flex-row md:justify-between">
   <div className=" w-full">
  {/* Header */}
  <div className="flex justify-between items-center gap-3 mb-4">
    <div className='flex gap-2 justify-center items-center'>
     {/*  <FaCalendarAlt className="text-primary text-lg  md:text-3xl"  /> */}
     
    <h3 className="text-sm md:text-xl font-bold text-primary">முன்பதிவு</h3>
    </div>
     <div className=" md:hidden">
    <button
      className="text-xs px-4 py-2 md:text-sm bg-primary text-white font-semibold md:px-4 md:py-2 rounded-lg hover:bg-opacity-90 transition"
      onClick={() => setMenuOpen(true)}
    >
      + Add
    </button>
  </div>
  </div>
  

 
 

  {/* Controls (Month & Year Navigation) */}
  <div className="flex items-center justify-end  mb-4">
    {/* Previous Button */}
    <button
      onClick={() =>
        setSelectedDate(
          new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth() - 1,
            1
          )
        )
      }
      className="p-1 md:p-2 text-[12px] md:text-sm rounded-md border border-gray-300  hover:bg-gray-100 transition"
      title="Previous Month"
    >
      <IoIosArrowBack className="text-gray-600 text-base" />
    </button>

    {/* Month Selector */}
    <select
      value={selectedDate.getMonth()}
      onChange={(e) =>
        setSelectedDate(
          new Date(selectedDate.getFullYear(), parseInt(e.target.value), 1)
        )
      }
      className="border text-[12px] border-gray-300 rounded-md px-2 py-1 md:px-4 md:py-1.5 md:text-sm  focus:outline-none focus:ring-2 focus:ring-orange-400"
    >
      {months.map((month, i) => (
        <option key={i} value={i}>
          {month}
        </option>
      ))}
    </select>

    {/* Year Selector */}
    <select
      value={selectedDate.getFullYear()}
      onChange={(e) =>
        setSelectedDate(
          new Date(parseInt(e.target.value), selectedDate.getMonth(), 1)
        )
      }
      className="border text-[12px] border-gray-300 rounded-md md:px-4 md:py-1.5 md:text-sm  focus:outline-none focus:ring-2 focus:ring-orange-400"
    >
      {Array.from({ length: 10 }, (_, i) => selectedDate.getFullYear() - 5 + i).map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      ))}
    </select>

    {/* Next Button */}
    <button
      onClick={() =>
        setSelectedDate(
          new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth() + 1,
            1
          )
        )
      }
      className="p-1 md:p-2 text-[12px] rounded-md border md:text-sm border-gray-300  hover:bg-gray-100 transition"
      title="Next Month"
    >
      <GrFormNext className="text-gray-600 text-base" />
    </button>
  </div>

  {/* Week Days */}
  <div className=" text-[9px] md:text-xs grid grid-cols-7 text-center font-semibold text-gray-600 mt-4 mb-2">
    {dayOfWeek.map((day) => (
      <div key={day} className="py-2 uppercase tracking-wide">{day}</div>
    ))}
  </div>

  {/* Calendar Grid */}
  <div className=" text-[12px] md:text-xs grid grid-cols-7 gap-2 sm:gap-4 text-center mt-2 overflow-x-auto">
    {daysInMonth().map((day, idx) => {
      const isToday = day && isSameDay(day, new Date());
      const formatted = day && formatDate(day);
      const eventsOnDay = day
        ? bookings.filter((item) => formatDate(new Date(item.date)) === formatted)
        : [];

      return (
        <div
          key={idx}
          onClick={() => day && setSelectedDate(day)}
          className={`
            relative text-[5px] aspect-square md:w-[50px] md:h-[50px] w-[30px] h-[30px] 
            flex items-center justify-center rounded-xl text-sm font-medium 
            transition cursor-pointer select-none
            ${!day ? "opacity-0 pointer-events-none" : ""}
            ${isToday ? "bg-orange-100 text-black" : "text-gray-700"}
            ${
              selectedDate?.toDateString() === day?.toDateString()
                ? "bg-primary text-white shadow-md"
                : "hover:bg-gray-100"
            }
          `}
        >
          {day?.getDate()}

          {/* Red Event Indicators */}
          {eventsOnDay.length > 0 && (
            <div className="flex justify-center gap-[2px] mt-1 absolute bottom-2 left-1/2 -translate-x-1/2">
              {eventsOnDay.slice(0, 3).map((_, i) => (
                <span
                  key={i}
                  className={`w-1.5 h-1.5 rounded-full ${
                    selectedDate?.toDateString() === day?.toDateString()
                      ? "bg-white"
                      : "bg-[#e94242]"
                  }`}
                ></span>
              ))}
              {eventsOnDay.length > 3 && (
                <span className="text-[5px] text-red-500 ml-1">
                  +{eventsOnDay.length - 3}
                </span>
              )}
            </div>
          )}
        </div>
      );
    })}
  </div>
</div>




       <div className=" px-3 md:px-6 py-6  w-[90%] h-[600px]  md:w-[500px]  rounded-l-2xl  flex flex-col ">
  {/* Header */}
  <div className="hidden md:flex justify-between items-center">
    <h1 className="text-xl font-bold text-primary">நிகழ்வுகள்</h1>
    <button
      onClick={() => setMenuOpen(true)}
      className="text-sm bg-primary text-white font-semibold px-4 py-2 rounded-md hover:bg-opacity-90 transition"
    >
      + 
    </button>
  </div>

  {/* Selected Date */}
  <div className="mt-3">
    <span className="text-sm text-gray-600">
      {selectedDate?.toDateString() || ""}
    </span>
  </div>

  {/* Event List */}
  <div className="flex-1 mt-4 overflow-y-auto pr-1">
    {selectedEvents.length > 0 ? (
      <div className="space-y-4">
        {selectedEvents.map((event, i) => (
          <div
            key={i}
            className="p-3 bg-[#f1f8f6] border rounded-xl shadow-sm hover:shadow-md transition"
          >
            <div className="flex justify-between">
              <div>
                <p className="text-[12px] md:text-sm font-semibold text-gray-800">
                  {event.event}
                </p>
                <p className="flex items-center text-[12px] md:text-sm text-gray-500 gap-2 mt-1">
                  <FaClock />
                  <span>
                    {event.startTime || "--"} – {event.endTime || "--"}
                  </span>
                </p>
              </div>
              <div className="flex-shrink-0">
                <button
                  onClick={() => setViewOpen(true)}
                  className="text-xs px-3 py-1.5 bg-primary text-white rounded-md font-semibold"
                >
                 விவரம் பார்க்கவும்
                </button>
              </div>
            </div>

            {/* View Modal */}
            {viewOpen && (
              <div className="fixed inset-0 z-50 bg-black bg-opacity-30 flex items-center justify-center px-4">
  <div className="w-full max-w-lg max-h-[90vh]  rounded-xl p-5 sm:p-6 overflow-y-auto ">
    
    {/* Close Button */}
    <div className="flex justify-end mb-2">
      <RxCross2
        size={22}
        className="cursor-pointer text-gray-500 hover:text-red-500"
        onClick={() => setViewOpen(false)}
      />
    </div>

    {/* Event Title */}
    <h2 className="md:text-xl font-bold text-primary mb-3">
      நிகழ்வு: <span className="">{event.event}</span>
    </h2>

    {/* Event Time */}
    <p className="text-[12px] md:text-sm text-gray-600 mb-4">
      <span className="font-semibold text-gray-700">நேரம்:</span>{" "}
      <strong>{event.startTime || "--"}</strong> – <strong>{event.endTime || "--"}</strong>
    </p>

    {/* Event Fields */}
    <div className="space-y-2 mb-4">
      {event?.feilds?.map((field, index) => (
        <div key={index} className="text-[12px] md:text-sm text-gray-800">
          <span className="font-semibold text-gray-700">{field?.label}:</span>{" "}
          {field?.value || "--"}
        </div>
      ))}
    </div>

    {/* Payment Section */}
    <div className="bg-gray-50 p-4 rounded-lg border space-y-2">
      <p className="text-[12px] md:text-sm text-gray-800">
        <span className="font-semibold">கட்டண முறை:</span>{" "}
        {event.paymentMode || "N/A"}
      </p>
      <p className="text-[12px] md:text-sm text-gray-800">
        <span className="font-semibold">அட்வான்ஸ் தொகை:</span>{" "}
        ₹{event.advanceAmount || "0"}
      </p>
      <p className= "text-[12px] md:text-sm text-gray-800">
        <span className="font-semibold">மொத்த தொகை:</span>{" "}
        ₹{event.totalAmount || "0"}
      </p>
    </div>

    {/* Generate Bill Button */}
    <div className="mt-4">
      <button
        onClick={() => setViewBill(true)}
        className="text-primary font-bold text-base hover:underline"
      >
        Generate Bill
      </button>
    </div>

    {/* Bill Entry Form */}
    {viewBill && (
      <div className="mt-5 space-y-5">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-[12px] md:text-sm font-medium text-gray-700 mb-1">
              Start Unit
            </label>
            <input
              type="number"
              placeholder="Start Unit"
              className="w-full border px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-300"
            />
          </div>
          <div>
            <label className="block text-[12px] md:text-sm font-medium text-gray-700 mb-1">
              End Unit
            </label>
            <input
              type="number"
              placeholder="End Unit"
              className="w-full border px-4 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-300"
            />
          </div>
        </div>

        <div className="flex justify-between gap-3">
          <button
            className="w-full text-[12px] bg-gray-200 md:text-sm text-gray-800 px-2 py-1 md:px-4 md:py-2 rounded-md font-semibold hover:bg-gray-300"
            onClick={() => setViewBill(false)}
          >
           மூடு
          </button>
          <button
            className="w-full bg-primary text-white md:px-4 md:py-2 rounded-md px-2 py-1 text-[12px] md:text-sm font-semibold hover:bg-orange-600"
          >
          புதுப்பிக்கவும்
          </button>
        </div>
      </div>
    )}
  </div>
</div>

            )}
          </div>
        ))}
      </div>
    ) : (
      <div className="flex items-center justify-center h-full">
        <p className="text-center text-gray-400 text-sm italic">
         இந்த நாளுக்கு நிகழ்வுகள் எதுவும் இல்லை.
        </p>
      </div>
    )}
  </div>
</div>

</div>

        {menuOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-30 z-50 flex justify-center items-center px-4 sm:px-6 md:px-10">
            <div className="w-full max-w-xl max-h-[90vh]  rounded-lg shadow-2xl relative sm:px-8 md:px-10 px-5 py-6 flex flex-col">
 
  <div className="flex justify-between items-center mb-4 sticky top-0 left-0  z-10 pb-2">
    <h2 className="text-primary text-xl font-bold">நிகழ்வுகள் படிவம்</h2>
    <ImCross
      fontSize={20}
      className="text-gray-500 font-bold hover:text-red-500 cursor-pointer"
      onClick={() => setMenuOpen(false)}
    />
  </div>

 
  <div className="overflow-y-auto flex-1 space-y-5 pb-32">
  
    <div className=" mb-0">
      <label className="block font-medium text-sm text-gray-600 mb-2">
       நிகழ்வின் பெயர்
      </label>
      <select
        className="rounded-md px-4 py-2 m-0 w-full border text-sm focus:outline-none focus:ring-2 focus:ring-orange-200"
        value={sel}
        onChange={(e) => setSel(e.target.value)}
      >
        <option value="">Select</option>
        {events?.map((data, i) => (
          <option key={i} value={data?.name}>
            {data?.name}
          </option>
        ))}
      </select>
    </div>

    {/* Dynamic Fields */}
    {events
      .find((c) => c?.name === sel)
      ?.feilds?.map((field, i) => (
        <div key={i}>
          <label className="block font-medium text-sm text-gray-600 mb-1">
            {field}
          </label>
          <input
            type="text"
            placeholder={`Enter ${field}`}
            value={
              formData?.feilds?.find(
                (f) => f?.label?.toLowerCase() === field?.toLowerCase()
              )?.value || ""
            }
            onChange={(e) => handleFiedlsChange(field, e.target.value)}
            className="rounded-md px-4 py-2 w-full border text-sm focus:outline-none focus:ring-2 focus:ring-orange-200"
          />
        </div>
      ))}

    {/* Time Inputs */}
    <div>
      <label className="block font-medium text-sm text-gray-600 mb-1">
       நேரம்:
      </label>
      {!hasTimeEvent ? (
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex flex-col flex-1">
            <label className="text-sm text-gray-600 mb-1">தொடக்க நேரம்</label>
            <input
              type="time"
              className="border rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-200"
              value={formData?.startTime}
              onChange={(e) => handleChange("startTime", e.target.value)}
            />
          </div>
          <div className="flex flex-col flex-1">
            <label className="text-sm text-gray-600 mb-1">முடிவு நேரம்</label>
            <input
              type="time"
              className="border rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-200"
              value={formData?.endTime}
              onChange={(e) => handleChange("endTime", e.target.value)}
            />
          </div>
        </div>
      ) : (
        <p className="text-red-500 text-sm">
        இந்த தேதிக்கு ஏற்கனவே நேரம் திட்டமிடப்பட்டுள்ளது.
        </p>
      )}
    </div>

    {/* Payment Fields */}
    <div>
      <label className="block font-medium text-sm text-gray-600 mb-1">
       கட்டண முறை
      </label>
      <input
        type="text"
        placeholder="Enter Method"
        value={formData.paymentMode || ""}
        onChange={(e) => handleChange("paymentMode", e.target.value)}
        className="rounded-md px-4 py-2 w-full border text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
      />
    </div>

    <div>
      <label className="block font-medium text-sm text-gray-600 mb-1">
      மொத்தம்
      </label>
      <input
        type="text"
        placeholder="Enter Total"
        value={formData.totalAmount || ""}
        onChange={(e) => handleChange("totalAmount", e.target.value)}
        className="rounded-md px-4 py-2 w-full border text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
      />
    </div>

    <div>
      <label className="block font-medium text-sm text-gray-600 mb-1">
      அட்வான்ஸ்
      </label>
      <input
        type="text"
        placeholder="Enter Advance"
        value={formData.advanceAmount || ""}
        onChange={(e) => handleChange("advanceAmount", e.target.value)}
        className="rounded-md px-4 py-2 w-full border text-sm focus:outline-none focus:ring-2 focus:ring-orange-400"
      />
    </div>
  </div>

  {/* Sticky Submit */}
  <div className="sticky bottom-0 left-0 pt-4 pb-3">
    <button
      className="w-full bg-primary text-white font-medium text-sm px-4 py-2 rounded-md transition"
      onClick={handleSubmit}
    >
      சமர்ப்பிக்கவும்
    </button>
  </div>
</div>

          </div>
        )}
      </div>
    </div>
  );
};

export default Booking;
